import { safe } from '../../documentos/commercialExcelUtils';
import { PK_DECLA_STATIC_ITEMS } from './pkDeclaStaticContent';

const LINE_H_STATIC = 3.35;
const PAGE_BOTTOM = 285;
const MARGIN = 14;

/**
 * Bloque legal PK Decla en PDF (flujo vertical; misma secuencia que Excel).
 * @returns {number} Y tras el bloque
 */
export function drawPkDeclaStaticBlockPdf(doc, startY) {
  let y = startY;

  const ensureSpace = (needed = LINE_H_STATIC) => {
    if (y + needed > PAGE_BOTTOM) {
      doc.addPage();
      y = MARGIN;
    }
  };

  const writeWrapped = (text) => {
    const wrapped = doc.splitTextToSize(safe(text), doc.internal.pageSize.getWidth() - MARGIN * 2);
    wrapped.forEach((ln) => {
      ensureSpace();
      doc.text(ln, MARGIN, y);
      y += LINE_H_STATIC;
    });
  };

  PK_DECLA_STATIC_ITEMS.forEach((item) => {
    if (item.type === 'text') {
      writeWrapped(item.value);
      if (item.tall) y += LINE_H_STATIC * 0.35;
    } else if (item.type === 'qa') {
      writeWrapped(item.question);
      ensureSpace();
      doc.text(`${item.answerLeft}    ${item.answerRight}`, MARGIN, y);
      y += LINE_H_STATIC;
    } else if (item.type === 'pair') {
      ensureSpace();
      doc.text(`${item.left}${item.right}`, MARGIN, y);
      y += LINE_H_STATIC;
    }
  });

  return y;
}
